<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

        <tt-card>
            <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListSalaryTypes" ltype="multi" typevar="g" [filterVal]="setting.searchtext"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

        <tt-divider ttRememberId="laboursalarytypes_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-list-legacy [listItems]="itemsListSalaryTypes" ltype="multi" typevar="g" [filterVal]="setting.searchtext"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
